import {Component, Input, OnInit} from '@angular/core';
import {CadastroEmpresaTunaComponent} from "../../fidelidade/tuna/cadastro-empresa/cadastro-empresa-tuna.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {DialogCloseResult, DialogService} from "@progress/kendo-angular-dialog";
import {EmpresaService} from "../../services/empresa.service";
import {FormaDePagamento} from "../../pedidos/objetos/FormaDePagamento";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {TunapayService} from "../../../../projects/loja/src/services/tunapay.service";
import {Router} from "@angular/router";
import {RotaGuardClient} from "../../guards/auth-loja.guard";

@Component({
  selector: 'app-meucardapio-pay-pagamento',
  templateUrl: './meucardapio-pay-pagamento.component.html',
  styleUrls: ['./meucardapio-pay-pagamento.component.scss']
})
export class MeucardapioPayPagamentoComponent implements OnInit {
  @Input() empresa: any = {}
  @Input() formasDePagamentoOnline: any = [];
  @Input() formasDePagamentoMciOnline: any = [];
  meucardapioPagamentosOnline: Array<FormaDePagamento> = [];
  loading = true;
  isAdmin = false;
  mostrarModalNegociar = false;
  taxaNegociada: number;
  salvandoTaxa = false;
  erroTaxa: string;

  mostrarModalNegociarPix = false;
  taxaNegociadaPix: number;
  salvandoTaxaPix = false;
  erroTaxaPix: string;
  erroCarregarMeucardapioPay: string;
  sincronizandoFormasPagamento = false;
  carregandoLiberacaoCellcoin = false;
  liberandoPixCellcoin = false;
  liberandoCartaoCellcoin = false;
  erroLiberacaoPixCellcoin: string;
  erroLiberacaoCartaoCellcoin: string;
  mensagemConsultaCredenciamentoCartaoCellcoin: string;
  statusConsultaCredenciamentoCartaoCellcoin: string;
  statusLiberacaoCellcoin: any;
  parametrosCredenciamentoCartao: any = {};
  origensCredenciamentoCartao: any = {};
  siteCredenciamentoCartao = '';
  tentouLiberarCartaoCellcoin = false;
  mostrarModalCredenciamentoCartaoCellcoin = false;
  mostrarModalWebhooksCellcoin = false;
  hostWebhooksCellcoin = '';
  statusWebhooksCellcoin: any;
  carregandoWebhooksCellcoin = false;
  salvandoWebhookCellcoinKey = '';
  salvandoWebhookCellcoinEntityKey = '';
  removendoWebhookCellcoinEntityKey = '';
  erroWebhooksCellcoin: string;
  propostaMigracaoCellcoin: any;
  carregandoMigracaoCellcoin = false;
  erroMigracaoCellcoin = '';
  configuracaoAtivacaoMeucardapioPay: any = {
    ativarComCellcoin: false,
    provedor: 'tuna',
    migracaoCellcoinDisponivel: false
  };
  innerHeight = window.innerHeight;
  private gruposWebhooksCellcoinCache: Array<any> = [];
  private webhooksCellcoinReferenciaCache: Array<any>;
  private hostWebhooksCellcoinCache = '';
  private readonly chaveLocalStorageHostWebhooksCellcoin = 'cellcoin.webhooks.host';
  private usuario: any;
  constructor(private empresaService: EmpresaService, private dialogService: DialogService,
              private autorizacaoService: AutorizacaoService, private tunapayService: TunapayService,
              private router: Router) { }

  ngOnInit(): void {
    this.usuario = this.autorizacaoService.getUser();
    if(this.usuario && this.usuario.superadmin) this.isAdmin = true;

    this.empresaService.obtenhaConfiguracaoAtivacaoMeucardapioPay()
      .then((configuracao: any) => {
        if(configuracao)
          this.configuracaoAtivacaoMeucardapioPay = configuracao;

        this.carregueMeucardapioPay();
      })
      .catch(() => this.carregueMeucardapioPay());
  }

  private carregueMeucardapioPay() {
    if(this.empresa.id && !this.empresa.meucardapioPay){
      this.empresaService.obntehaPadraoMCIPay(this.configuracaoAtivacaoMeucardapioPay.provedor)
        .then((meucardapioPay: any) => {
          if(meucardapioPay && meucardapioPay.idLoja)
            this.empresa.meucardapioPay = meucardapioPay

          this.finalizeCarregamento();
      }).catch((erro: any) => {
        this.erroCarregarMeucardapioPay = erro && erro.message ? erro.message : erro;
        this.finalizeCarregamento();
      })
    } else {
      if(this.processando())
        this.sincronizeStatusRegistroMCIPay();

      this.finalizeCarregamento();
    }
  }

  private finalizeCarregamento() {
    if(this.empresa.meucardapioPay && this.empresa.meucardapioPay.pixLiberado){
      if(this.empresa.meucardapioPay.ativacaoStatus === '0'){
        //todo: verifiar com pessoal tuna se depois liberado pix a conta ainda pode ser reprovada
        //todo: depois tiver cartao funcioando melhorar esse codigo, em analise devera ser por forma de pagamento
      //  this.empresa.meucardapioPay.ativacaoStatus = '1'
      }
    }


    this.formasDePagamentoMciOnline =
      this.formasDePagamentoOnline.filter((item: any) => this.ehFormaDoProvedorMeuCardapioPay(item))

    this.formasDePagamentoMciOnline.forEach((item: any) => {
      if(!item.pix)
        item.soAdminAtiva = true;
    })

    this.loading  = false;

    if(this.podeExibirBannerMigracaoCellcoin())
      this.carregueMigracaoCellcoin();

    if(this.ehCellcoin() && this.cadastroAprovadoMCPay())
      this.carregueStatusLiberacaoCellcoin();
  }

  carregueMigracaoCellcoin() {
    if(this.carregandoMigracaoCellcoin) return;

    this.carregandoMigracaoCellcoin = true;
    this.erroMigracaoCellcoin = '';
    this.empresaService.obtenhaPropostaCellcoin()
      .then((payload: any) => {
        this.propostaMigracaoCellcoin = payload?.cellcoinPropostaAtual || null;
        this.carregandoMigracaoCellcoin = false;
      })
      .catch((erro: any) => {
        this.erroMigracaoCellcoin = erro?.message || erro;
        this.carregandoMigracaoCellcoin = false;
      });
  }

  podeExibirBannerMigracaoCellcoin() {
    return this.configuracaoAtivacaoMeucardapioPay.migracaoCellcoinDisponivel &&
      this.ehTuna() && this.empresa?.meucardapioPay?.lojaAtivou &&
      this.empresa?.meucardapioPay?.ativacaoStatus === '1';
  }

  migracaoCellcoinReprovada() {
    const proposta = this.propostaMigracaoCellcoin;
    const status = String(proposta?.cellcoinStatus || '').toUpperCase();

    return proposta?.ativacaoStatus === '2' ||
      ['REPROVED', 'ERROR', 'RESOURCE_ERROR'].indexOf(status) >= 0 ||
      !!proposta?.rejectionEntity;
  }

  migracaoCellcoinFinalizando() {
    return !!this.propostaMigracaoCellcoin?.account && !this.migracaoCellcoinReprovada();
  }

  migracaoCellcoinEmAndamento() {
    return !!this.propostaMigracaoCellcoin &&
      !this.migracaoCellcoinReprovada() &&
      !this.migracaoCellcoinFinalizando();
  }

  tituloBannerMigracaoCellcoin() {
    if(this.migracaoCellcoinReprovada()) return 'Revise seu cadastro para migrar';
    if(this.migracaoCellcoinFinalizando()) return 'Migração em fase final';
    if(this.migracaoCellcoinEmAndamento()) return 'Migração para o Meu Cardápio Pay 2.0 em andamento';
    return 'Migre para o Meu Cardápio Pay 2.0';
  }

  descricaoBannerMigracaoCellcoin() {
    if(this.migracaoCellcoinReprovada())
      return this.propostaMigracaoCellcoin?.rejectionReason || this.propostaMigracaoCellcoin?.erro ||
        'O cadastro não foi aprovado. Revise os dados e envie uma nova proposta.';

    if(this.migracaoCellcoinFinalizando()){
      if(this.propostaMigracaoCellcoin?.migrationStatus === 'ERROR')
        return this.propostaMigracaoCellcoin?.migrationError || 'Não foi possível concluir a migração. Tente atualizar novamente.';
      return 'A conta foi criada. Estamos gerando a chave Pix e concluindo a troca automaticamente.';
    }

    if(this.migracaoCellcoinEmAndamento())
      return 'Continue acompanhando a análise. Seus pagamentos Tuna permanecem ativos até a conclusão.';

    return 'Receba Pix em D+0 diretamente na sua conta. A operação atual continuará ativa durante o cadastro.';
  }

  textoBotaoMigracaoCellcoin() {
    if(this.migracaoCellcoinReprovada()) return 'Revisar cadastro';
    if(this.propostaMigracaoCellcoin) return 'Acompanhar migração';
    return 'Migrar agora';
  }

  abraMigracaoCellcoin() {
    this.router.navigate(['/admin/meucardapio-pay/ativacao']);
  }


  abrirModalRegistrarEmpresaTuna() {

    const windowRef = this.dialogService.open( {
        title: null,
        content: CadastroEmpresaTunaComponent,
        minWidth: 800,
        width: window.innerWidth > 800 ? 800 : window.innerWidth,
        maxHeight: window.innerHeight - 100,
        cssClass: 'bsModal'
      }
    );

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    let tela: any = windowRef.content.instance;

    tela.empresa = this.empresa;

    windowRef.result.subscribe((result: any) => {
      if( !(result instanceof DialogCloseResult  ))
        this.recarreguePagina();
    });

  }

  ativeMeuCardapioPay() {
    if(this.configuracaoAtivacaoMeucardapioPay.ativarComCellcoin)
      return this.abrirAtivacaoEmpresaCellcoin();

    this.abrirModalRegistrarEmpresaTuna();
  }

  abrirAtivacaoEmpresaCellcoin() {
    this.abraMigracaoCellcoin();
  }

  registreEmpresaCellcoin() {
    if(this.empresa.meucardapioPay?.sincronizando) return;

    this.empresa.meucardapioPay.sincronizando = true;
    this.empresaService.registreEmpresaCellcoin({})
      .then((retorno: any) => {
        this.empresa.meucardapioPay.sincronizando = false;
        if(retorno && retorno.id)
          this.empresa.meucardapioPay = retorno;
      })
      .catch((err) => {
        this.empresa.meucardapioPay.sincronizando = false;
        alert(err);
      });
  }

  recarreguePagina(){
    window.location.assign('/admin/loja/formaspagamento/onlinemci');
  }

  sincronizeFormasPagamentoMeucardapioPay() {
    if(this.sincronizandoFormasPagamento) return;

    this.sincronizandoFormasPagamento = true;
    this.empresaService.sincronizeFormasPagamentoMeucardapioPay(this.provedorMeuCardapioPay())
      .then(() => this.recarreguePagina())
      .catch((err) => {
        this.sincronizandoFormasPagamento = false;
        alert(err);
      });
  }

  carregueStatusLiberacaoCellcoin(sincronizarCredenciamentoCartao: boolean = false) {
    if(this.carregandoLiberacaoCellcoin) return;

    this.carregandoLiberacaoCellcoin = true;
    if(sincronizarCredenciamentoCartao){
      this.erroLiberacaoCartaoCellcoin = '';
      this.mensagemConsultaCredenciamentoCartaoCellcoin = '';
      this.statusConsultaCredenciamentoCartaoCellcoin = '';
    }

    this.empresaService.obtenhaStatusPagamentosCellcoin(sincronizarCredenciamentoCartao)
      .then((status: any) => {
        this.statusLiberacaoCellcoin = status;
        this.atualizeParametrosCredenciamentoCartao(status);
        this.atualizeMensagemConsultaCredenciamentoCartao(status);
        this.carregandoLiberacaoCellcoin = false;
      })
      .catch((erro: any) => {
        this.carregandoLiberacaoCellcoin = false;
        if(sincronizarCredenciamentoCartao)
          this.erroLiberacaoCartaoCellcoin = erro?.message || erro;
        else
          this.erroLiberacaoPixCellcoin = erro?.message || erro;
      });
  }

  carregueStatusCredenciamentoCartaoCellcoin() {
    this.carregueStatusLiberacaoCellcoin(true);
  }

  liberePixCellcoin() {
    if(this.liberandoPixCellcoin) return;

    this.liberandoPixCellcoin = true;
    this.erroLiberacaoPixCellcoin = '';
    this.empresaService.liberePagamentoPixCellcoin()
      .then((status: any) => {
        this.statusLiberacaoCellcoin = status;
        this.liberandoPixCellcoin = false;
        this.recarreguePagina();
      })
      .catch((erro: any) => {
        this.liberandoPixCellcoin = false;
        this.erroLiberacaoPixCellcoin = erro?.message || erro;
      });
  }

  libereCartaoCellcoin() {
    if(this.liberandoCartaoCellcoin) return;

    this.tentouLiberarCartaoCellcoin = true;
    if(!this.statusCartaoCellcoin().credenciado && !this.parametrosCredenciamentoCartaoValidos()){
      this.erroLiberacaoCartaoCellcoin = 'Preencha os dados de credenciamento do cartão antes de liberar.';
      return;
    }

    this.liberandoCartaoCellcoin = true;
    this.erroLiberacaoCartaoCellcoin = '';
    this.empresaService.liberePagamentoCartaoCellcoin(this.parametrosCredenciamentoCartao)
      .then((status: any) => {
        this.statusLiberacaoCellcoin = status;
        this.atualizeParametrosCredenciamentoCartao(status);
        this.liberandoCartaoCellcoin = false;
        this.fecheModalCredenciamentoCartaoCellcoin();
      })
      .catch((erro: any) => {
        this.liberandoCartaoCellcoin = false;
        this.erroLiberacaoCartaoCellcoin = erro?.message || erro;
      });
  }

  abraLiberacaoCartaoCellcoin() {
    if(this.podeEditarCredenciamentoCartaoCellcoin()){
      this.erroLiberacaoCartaoCellcoin = '';
      this.tentouLiberarCartaoCellcoin = false;
      this.mostrarModalCredenciamentoCartaoCellcoin = true;
      return;
    }

    this.libereCartaoCellcoin();
  }

  fecheModalCredenciamentoCartaoCellcoin() {
    this.mostrarModalCredenciamentoCartaoCellcoin = false;
  }

  sincronizeStatusRegistroMCIPay() {
    if(this.empresa.meucardapioPay.sincronizando) return;

    this.empresa.meucardapioPay.sincronizando = true;

    const sincronizacao = this.ehCellcoin() ?
      this.empresaService.verifiqueRetornoRegistroCellcoin() :
      this.empresaService.verifiqueRetornoRegistroTuna();

    sincronizacao.then((retorno: any) => {
      this.empresa.meucardapioPay.sincronizando = false;
      if(retorno && retorno.id){
        if(this.empresa.meucardapioPay.ativacaoStatus !== retorno.ativacaoStatus ||
           retorno.pixLiberado && !this.empresa.meucardapioPay.pixLiberado ){
          this.recarreguePagina();
        }
        this.empresa.meucardapioPay = retorno;
      }
    }).catch((err) => {
      this.empresa.meucardapioPay.sincronizando = false; alert(err)
    });
  }

  estaEmAnalise() {
    return this.empresa.meucardapioPay && !this.cadastroAprovadoMCPay() && this.empresa.meucardapioPay.ativacaoStatus === '0';
  }

  processando(){
    return this.empresa.meucardapioPay && !this.cadastroAprovadoMCPay() && this.empresa.meucardapioPay.ativacaoStatus ===  "P";
  }

  naoAprovado() {
    return this.empresa.meucardapioPay && !this.cadastroAprovadoMCPay() && this.empresa.meucardapioPay.ativacaoStatus === '2'
  }

  deveExibirCardMeucardapioPay() {
    const meucardapioPay = this.empresa.meucardapioPay;
    if(!meucardapioPay?.ativacaoStatus) return false;

    return !!(meucardapioPay.lojaAtivou || this.cadastroAprovadoMCPay());
  }

  deveExibirCardAtivacaoMeucardapioPay() {
    const meucardapioPay = this.empresa.meucardapioPay;
    if(!meucardapioPay) return false;
    if(this.cadastroAprovadoMCPay()) return false;

    return !meucardapioPay.ativacaoStatus || !meucardapioPay.lojaAtivou;
  }

  cadastroAprovadoMCPay() {
    const meucardapioPay = this.empresa.meucardapioPay;
    if(!meucardapioPay) return false;

    if(this.ehCellcoin())
      return this.contaCellcoinAtiva();

    return meucardapioPay.ativacaoStatus === '1';
  }

  private contaCellcoinAtiva() {
    const meucardapioPay = this.empresa.meucardapioPay;
    const conta = meucardapioPay?.cellcoinAccount;
    const status = this.normalizeStatusContaCellcoin(conta?.accountStatus || conta?.account_status || conta?.status);

    if(status)
      return !!conta?.account && (status === 'ATIVO' || status === 'ACTIVE');

    return !!conta?.account &&
      !!meucardapioPay.lojaAtivou &&
      meucardapioPay.ativacaoStatus === '1';
  }

  private normalizeStatusContaCellcoin(status: any) {
    return String(status || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase();
  }

  ehCellcoin() {
    return this.empresa.meucardapioPay?.provedor === 'cellcoin';
  }

  ehTuna() {
    const provedor = this.empresa.meucardapioPay?.provedor;
    return !provedor || provedor === 'tuna';
  }

  possuiFormasPagamentoDoProvedor() {
    return this.formasDePagamentoMciOnline && this.formasDePagamentoMciOnline.length > 0;
  }

  possuiFormaPixDoProvedor() {
    return !!(this.formasDePagamentoMciOnline || []).find((forma: any) => forma.pix);
  }

  possuiFormaCartaoDoProvedor() {
    return !!(this.formasDePagamentoMciOnline || []).find((forma: any) => !forma.pix && !forma.carteirasDigitais);
  }

  faltaFormaPagamentoLiberada() {
    const meucardapioPay = this.empresa.meucardapioPay;

    if(!meucardapioPay) return false;

    return !!((meucardapioPay.pixLiberado && !this.possuiFormaPixDoProvedor()) ||
      (meucardapioPay.cartaoCreditoLiberado && !this.possuiFormaCartaoDoProvedor()));
  }

  podeGerarFormasPagamentoMeucardapioPay() {
    if(this.ehCellcoin()) return false;

    return this.empresa.meucardapioPay?.lojaAtivou &&
      this.empresa.meucardapioPay?.ativacaoStatus === '1' &&
      this.faltaFormaPagamentoLiberada();
  }

  tituloGerarFormasPagamento() {
    if(!this.possuiFormasPagamentoDoProvedor())
      return `Nenhuma forma de pagamento ${this.nomeProvedorMeuCardapioPay()} encontrada`;

    return `Há formas de pagamento ${this.nomeProvedorMeuCardapioPay()} pendentes`;
  }

  nomeProvedorMeuCardapioPay() {
    return this.ehCellcoin() ? 'Cellcoin' : 'Tuna';
  }

  possuiValidacaoDocumentosCellcoin() {
    return this.ehCellcoin() && !!this.empresa.meucardapioPay?.cellcoinPropostaAtual?.documentscopyUrl;
  }

  podeExibirLiberacaoCellcoin() {
    return this.ehCellcoin() &&
      this.cadastroAprovadoMCPay() &&
      this.temCardLiberacaoCellcoin();
  }

  statusPixCellcoin() {
    return this.statusLiberacaoCellcoin?.pix || {};
  }

  chavePixCellcoinAtiva() {
    const pix = this.statusPixCellcoin();
    return this.ehCellcoin() && pix.pronto && (pix.chave || pix.chaveMascarada);
  }

  statusCartaoCellcoin() {
    return this.statusLiberacaoCellcoin?.cartao || {};
  }

  atualizeMensagemConsultaCredenciamentoCartao(status: any) {
    const consulta = status?.cartao?.consultaCredenciamento;

    if(!consulta) return;

    this.mensagemConsultaCredenciamentoCartaoCellcoin = consulta.mensagem || '';
    this.statusConsultaCredenciamentoCartaoCellcoin = consulta.status || '';
  }

  temCardLiberacaoCellcoin() {
    if(!this.statusLiberacaoCellcoin) return true;

    return this.deveExibirCardLiberacaoPixCellcoin() ||
      this.deveExibirCardLiberacaoCartaoCellcoin();
  }

  deveExibirCardLiberacaoPixCellcoin() {
    const pix = this.statusPixCellcoin();

    return !(pix.pronto || (pix.chaveCriada && pix.formaCriada));
  }

  deveExibirCardLiberacaoCartaoCellcoin() {
    return !this.statusCartaoCellcoin().pronto;
  }

  podeExibirLiberacaoPixNoCard() {
    return this.podeExibirLiberacaoCellcoin() && this.deveExibirCardLiberacaoPixCellcoin();
  }

  podeExibirLiberacaoCartaoNoCard() {
    return this.podeExibirLiberacaoCellcoin() && this.deveExibirCardLiberacaoCartaoCellcoin();
  }

  podeAlterarTaxaPix() {
    if(!this.isAdmin) return false;
    if(this.ehTuna()) return true;

    const pix = this.statusPixCellcoin();
    return this.ehCellcoin() && !!(pix.pronto || (pix.chaveCriada && pix.formaCriada));
  }

  podeAlterarTaxaCartao() {
    if(!this.isAdmin) return false;
    if(this.ehTuna()) return true;

    return this.ehCellcoin() && !!this.statusCartaoCellcoin().pronto;
  }

  podeGerenciarWebhooksCellcoin() {
    return this.isAdmin && this.ehCellcoin() && Number(this.empresa?.id) === 1;
  }

  podeVerDetalhesContaCellcoin() {
    return RotaGuardClient.visualizarContaCellcoin(this.usuario) &&
      this.ehCellcoin() && !!this.empresa?.meucardapioPay?.cellcoinAccount?.account;
  }

  abraPaginaDetalhesContaCellcoin() {
    this.router.navigate(['/admin/loja/conta-mcpay']);
  }

  abraModalWebhooksCellcoin() {
    this.mostrarModalWebhooksCellcoin = true;
    this.erroWebhooksCellcoin = '';

    if(!this.hostWebhooksCellcoin)
      this.hostWebhooksCellcoin = this.obtenhaHostWebhooksCellcoinSalvo();

    this.carregueWebhooksCellcoin();
  }

  fecheModalWebhooksCellcoin() {
    this.mostrarModalWebhooksCellcoin = false;
  }

  carregueWebhooksCellcoin() {
    if(this.carregandoWebhooksCellcoin || this.removendoWebhookCellcoinEntityKey) return;

    this.carregandoWebhooksCellcoin = true;
    this.erroWebhooksCellcoin = '';
    this.empresaService.listeWebhooksCellcoin(this.hostWebhooksCellcoin)
      .then((status: any) => {
        this.statusWebhooksCellcoin = status;
        this.hostWebhooksCellcoin = status?.host || this.hostWebhooksCellcoin;
        this.salveHostWebhooksCellcoin();
        this.carregandoWebhooksCellcoin = false;
      })
      .catch((erro: any) => {
        this.erroWebhooksCellcoin = erro?.message || erro;
        this.carregandoWebhooksCellcoin = false;
      });
  }

  webhooksCellcoin() {
    return this.statusWebhooksCellcoin?.webhooks || [];
  }

  gruposWebhooksCellcoin() {
    const webhooks = this.webhooksCellcoin();
    const host = this.hostWebhooksCellcoin;

    if(this.webhooksCellcoinReferenciaCache === webhooks && this.hostWebhooksCellcoinCache === host)
      return this.gruposWebhooksCellcoinCache;

    const grupos: Array<any> = [];

    webhooks.forEach((webhook: any) => {
      let grupo = grupos.find((item: any) => item.path === webhook.path);

      if(!grupo){
        grupo = {
          key: webhook.path,
          path: webhook.path,
          webhookUrlEsperada: webhook.webhookUrlEsperada,
          webhooks: []
        };
        grupos.push(grupo);
      }

      grupo.webhooks.push(webhook);
    });

    this.webhooksCellcoinReferenciaCache = webhooks;
    this.hostWebhooksCellcoinCache = host;
    this.gruposWebhooksCellcoinCache = grupos;

    return this.gruposWebhooksCellcoinCache;
  }

  trackByGrupoWebhookCellcoin(indice: number, grupo: any) {
    return grupo?.key || indice;
  }

  trackByWebhookCellcoin(indice: number, webhook: any) {
    return webhook?.key || indice;
  }

  salveGrupoWebhooksCellcoin(grupo: any) {
    if(!grupo || this.salvandoWebhookCellcoinKey || this.removendoWebhookCellcoinEntityKey) return;

    const pendentes = (grupo.webhooks || []).filter((webhook: any) => !webhook.configurado);
    if(!pendentes.length) return;

    this.salveWebhooksCellcoinEmSequencia(pendentes, grupo.key);
  }

  salveTodosWebhooksCellcoin() {
    if(this.salvandoWebhookCellcoinKey || this.removendoWebhookCellcoinEntityKey) return;

    const pendentes = this.webhooksCellcoin().filter((webhook: any) => !webhook.configurado);
    if(!pendentes.length) return;

    this.salveWebhooksCellcoinEmSequencia(pendentes, 'todos');
  }

  podeSalvarTodosWebhooksCellcoin() {
    return !!(this.webhooksCellcoin().some((webhook: any) => !webhook.configurado) &&
      !this.carregandoWebhooksCellcoin &&
      !this.salvandoWebhookCellcoinKey &&
      !this.removendoWebhookCellcoinEntityKey &&
      this.hostWebhooksCellcoin);
  }

  salvandoTodosWebhooksCellcoin() {
    return this.salvandoWebhookCellcoinKey === 'todos';
  }

  private salveWebhooksCellcoinEmSequencia(webhooks: Array<any>, chave: string) {
    this.salvandoWebhookCellcoinKey = chave;
    this.erroWebhooksCellcoin = '';

    let sequencia = Promise.resolve();
    webhooks.forEach((webhook: any) => {
      sequencia = sequencia.then(() => {
        this.salvandoWebhookCellcoinEntityKey = webhook.key;
        return this.empresaService.salveWebhookCellcoin(webhook.key, this.hostWebhooksCellcoin)
          .then((status: any) => {
            this.statusWebhooksCellcoin = status;
            this.hostWebhooksCellcoin = status?.host || this.hostWebhooksCellcoin;
            this.salveHostWebhooksCellcoin();
          });
      });
    });

    sequencia
      .then(() => {
        this.salvandoWebhookCellcoinKey = '';
        this.salvandoWebhookCellcoinEntityKey = '';
      })
      .catch((erro: any) => {
        this.erroWebhooksCellcoin = erro?.message || erro;
        this.salvandoWebhookCellcoinKey = '';
        this.salvandoWebhookCellcoinEntityKey = '';
      });
  }

  webhookCellcoinEntitySalvando(webhook: any) {
    return this.salvandoWebhookCellcoinEntityKey === webhook?.key;
  }

  webhookCellcoinEntityRemovendo(webhook: any) {
    return this.removendoWebhookCellcoinEntityKey === webhook?.key;
  }

  removaWebhookCellcoin(webhook: any, evento: any = null) {
    evento?.preventDefault();
    evento?.stopPropagation();

    if(!webhook?.subscriptionId || this.removendoWebhookCellcoinEntityKey) return;

    this.removendoWebhookCellcoinEntityKey = webhook.key;
    this.erroWebhooksCellcoin = '';
    this.empresaService.removaWebhookCellcoin(webhook.key, this.hostWebhooksCellcoin)
      .then((status: any) => {
        this.statusWebhooksCellcoin = status;
        this.hostWebhooksCellcoin = status?.host || this.hostWebhooksCellcoin;
        this.salveHostWebhooksCellcoin();
        this.removendoWebhookCellcoinEntityKey = '';
      })
      .catch((erro: any) => {
        this.erroWebhooksCellcoin = erro?.message || erro;
        this.removendoWebhookCellcoinEntityKey = '';
      });
  }

  classeStatusWebhookCellcoin(webhook: any) {
    if(webhook?.status === 'CONFIGURADO') return 'badge-success';
    if(webhook?.status === 'NAO_CADASTRADO') return 'badge-danger';
    return 'badge-warning';
  }

  grupoWebhooksCellcoinSalvando(grupo: any) {
    return this.salvandoWebhookCellcoinKey === grupo?.key;
  }

  grupoWebhooksCellcoinPodeSalvar(grupo: any) {
    return !!(grupo &&
      (grupo.webhooks || []).some((webhook: any) => !webhook.configurado) &&
      !this.carregandoWebhooksCellcoin &&
      !this.salvandoWebhookCellcoinKey &&
      !this.removendoWebhookCellcoinEntityKey &&
      this.hostWebhooksCellcoin);
  }

  quantidadeWebhooksConfigurados(grupo: any) {
    return (grupo?.webhooks || []).filter((webhook: any) => webhook.configurado).length;
  }

  mudouHostWebhooksCellcoin() {
    this.salveHostWebhooksCellcoin();
    this.recalculeUrlsEsperadasWebhooksCellcoin();
  }

  normalizeHostWebhooksCellcoinNoCampo() {
    this.hostWebhooksCellcoin = this.normalizeHostWebhooksCellcoin(this.hostWebhooksCellcoin);
    this.salveHostWebhooksCellcoin();
    this.recalculeUrlsEsperadasWebhooksCellcoin();
  }

  private obtenhaHostWebhooksCellcoinSalvo() {
    const hostSalvo = localStorage.getItem(this.chaveLocalStorageHostWebhooksCellcoin);
    return hostSalvo || window.location.origin;
  }

  private salveHostWebhooksCellcoin() {
    const host = this.normalizeHostWebhooksCellcoin(this.hostWebhooksCellcoin);
    if(host)
      localStorage.setItem(this.chaveLocalStorageHostWebhooksCellcoin, host);
  }

  private recalculeUrlsEsperadasWebhooksCellcoin() {
    if(!this.statusWebhooksCellcoin?.webhooks) return;

    const host = this.normalizeHostWebhooksCellcoin(this.hostWebhooksCellcoin);

    this.statusWebhooksCellcoin.webhooks.forEach((webhook: any) => {
      webhook.webhookUrlEsperada = host ? `${host}${webhook.path}` : webhook.path;

      if(!webhook.subscriptionId){
        webhook.webhookUrlAtual = '';
        webhook.status = 'NAO_CADASTRADO';
        webhook.statusTexto = 'Nao cadastrado';
        webhook.configurado = false;
        return;
      }

      if(webhook.webhookUrlAtual && webhook.webhookUrlAtual !== webhook.webhookUrlEsperada){
        webhook.status = 'URL_DIFERENTE';
        webhook.statusTexto = 'URL diferente';
        webhook.configurado = false;
      } else if(webhook.status === 'URL_DIFERENTE') {
        webhook.status = 'CONFIGURADO';
        webhook.statusTexto = 'Configurado';
        webhook.configurado = true;
      }
    });
  }

  private normalizeHostWebhooksCellcoin(host: any) {
    let valor = String(host || '').trim();
    if(!valor) return '';

    if(!/^https?:\/\//i.test(valor))
      valor = 'https://' + valor;

    return valor.replace(/\/+$/, '');
  }

  atualizeParametrosCredenciamentoCartao(status: any) {
    const parametros = status?.cartao?.parametrosCredenciamento;
    if(!parametros) return;

    this.parametrosCredenciamentoCartao = {
      softDescriptor: parametros.softDescriptor || '',
      cnae: parametros.cnae || '',
      businessDescriptor: parametros.businessDescriptor || '',
      monthlyIncome: parametros.monthlyIncome || null
    };
    this.siteCredenciamentoCartao = parametros.website || '';
    this.origensCredenciamentoCartao = status?.cartao?.origensCredenciamento || {};
    this.tentouLiberarCartaoCellcoin = false;
  }

  classeStatusLiberacaoCellcoin(statusPagamento: any) {
    if(statusPagamento?.pronto)
      return 'badge-success';

    if(statusPagamento?.status === 'CREDENCIAMENTO_REJEITADO')
      return 'badge-danger';

    if(this.statusLiberacaoCellcoin?.contaAtiva)
      return 'badge-warning';

    return 'badge-secondary';
  }

  classeMensagemConsultaCredenciamentoCartaoCellcoin() {
    const status = String(this.statusConsultaCredenciamentoCartaoCellcoin || '').toUpperCase();

    if(status === 'APPROVED') return 'alert-success';
    if(status === 'ERROR' || status === 'REJECTED') return 'alert-danger';

    return 'alert-info';
  }

  textoStatusPixCellcoin() {
    const status = this.statusPixCellcoin().status;

    if(status === 'PRONTO') return 'Liberado';
    if(status === 'PENDENTE_FORMA') return 'Criar forma Pix';
    if(status === 'PENDENTE_LIBERACAO') return 'Finalizar liberação';
    if(status === 'PENDENTE_CHAVE') return 'Criar chave Pix';
    return 'Aguardando conta';
  }

  textoStatusCartaoCellcoin() {
    const status = this.statusCartaoCellcoin().status;

    if(status === 'PRONTO') return 'Liberado';
    if(status === 'PENDENTE_FORMA') return 'Criar forma Cartão';
    if(status === 'CREDENCIAMENTO_EM_ANALISE') return 'Em análise';
    if(status === 'CREDENCIAMENTO_REJEITADO') return 'Rejeitado';
    if(status === 'PENDENTE_CREDENCIAMENTO') return 'Solicitar credenciamento';
    return 'Aguardando conta';
  }

  textoBotaoPixCellcoin() {
    const status = this.statusPixCellcoin().status;

    if(status === 'PENDENTE_FORMA') return 'Criar forma Pix';
    if(status === 'PENDENTE_LIBERACAO') return 'Finalizar liberação Pix';
    return 'Liberar Pix';
  }

  textoBotaoCartaoCellcoin() {
    const status = this.statusCartaoCellcoin().status;

    if(status === 'PENDENTE_FORMA') return 'Criar forma Cartão';
    if(status === 'CREDENCIAMENTO_REJEITADO') return 'Enviar nova solicitação';
    if(status === 'CREDENCIAMENTO_EM_ANALISE') return 'Aguardando Cellcoin';
    return 'Solicitar Credenciamento';
  }

  podeLiberarPixCellcoin() {
    return this.statusLiberacaoCellcoin?.contaAtiva && !this.statusPixCellcoin().pronto;
  }

  podeLiberarCartaoCellcoin() {
    return this.statusLiberacaoCellcoin?.contaAtiva &&
      !this.statusCartaoCellcoin().pronto &&
      this.statusCartaoCellcoin().status !== 'CREDENCIAMENTO_EM_ANALISE';
  }

  podeEditarCredenciamentoCartaoCellcoin() {
    const status = this.statusCartaoCellcoin().status;
    return !this.statusCartaoCellcoin().credenciado && status !== 'CREDENCIAMENTO_EM_ANALISE';
  }

  parametrosCredenciamentoCartaoValidos() {
    const parametros = this.parametrosCredenciamentoCartao || {};
    return !!(
      this.texto(parametros.softDescriptor) &&
      this.texto(parametros.softDescriptor).length <= 18 &&
      this.texto(parametros.businessDescriptor) &&
      ( this.apenasDigitos(parametros.cnae).length === 5  || this.apenasDigitos(parametros.cnae).length === 7 ) &&
      Number(parametros.monthlyIncome || 0) > 0
    );
  }

  campoCredenciamentoCartaoInvalido(campo: string) {
    if(!this.tentouLiberarCartaoCellcoin) return false;

    const valor = this.parametrosCredenciamentoCartao?.[campo];
    if(campo === 'cnae')
      return this.apenasDigitos(valor).length  > 7 || this.apenasDigitos(valor).length  <  5;
    if(campo === 'softDescriptor') return !this.texto(valor) || this.texto(valor).length > 18;
    if(campo === 'monthlyIncome') return !(Number(valor || 0) > 0);
    return !this.texto(valor);
  }

  mensagemCampoCredenciamentoCartao(campo: string) {
    if(!this.campoCredenciamentoCartaoInvalido(campo)) return '';

    if(campo === 'cnae') return 'Informe um CNAE válido';
    if(campo === 'monthlyIncome') return 'Informe o faturamento mensal.';
    if(campo === 'softDescriptor') return 'Informe o nome que aparece na fatura com no máximo 18 caracteres.';
    if(campo === 'businessDescriptor') return 'Informe a descrição do negócio.';

    return 'Campo obrigatório.';
  }

  origemParametroCredenciamentoCartao(campo: string) {
    return this.origensCredenciamentoCartao?.[campo] || 'Preenchido manualmente';
  }

  ajudaCampoCredenciamentoCartao(campo: string) {
    if(campo === 'softDescriptor') return 'Texto curto que aparece na fatura do cliente.';
    if(campo === 'cnae') return 'Código CNAE principal da atividade da loja.';
    if(campo === 'businessDescriptor') return 'Descrição comercial da loja enviada para análise.';
    if(campo === 'monthlyIncome') return 'Faturamento mensal estimado da loja.';

    return '';
  }

  private texto(valor: any) {
    return valor == null ? '' : String(valor).trim();
  }

  private apenasDigitos(valor: any) {
    return this.texto(valor).replace(/\D/g, '');
  }

  abraValidacaoDocumentosCellcoin() {
    const url = this.empresa.meucardapioPay?.cellcoinPropostaAtual?.documentscopyUrl;

    if(url)
      window.open(url, '_blank');
  }

  abrirModalNegociar() {
    this.taxaNegociada = this.empresa.meucardapioPay.cartaoTaxaNegociada ?
      (this.empresa.meucardapioPay.cartaoTaxaNegociada  ) :
      (this.empresa.meucardapioPay.contratoMeucardapioPay.taxaCartao * 100);
    this.mostrarModalNegociar = true;
  }

  fecharModalNegociar() {
    this.mostrarModalNegociar = false;
  }

  salvarTaxaNegociada() {
    if (this.salvandoTaxa) return;

    this.salvandoTaxa = true;
    this.tunapayService.atualizeTaxaNegociada({ taxaNegociada: this.taxaNegociada })
      .then((res: any) => {
        this.salvandoTaxa = false;
        this.empresa.meucardapioPay.cartaoTaxaNegociada = this.taxaNegociada;
        this.fecharModalNegociar();
      })
      .catch((err) => {
        this.salvandoTaxa = false;
        this.erroTaxa = err.message || err;
      });
  }

  abrirModalNegociarPix() {
    this.taxaNegociadaPix = this.empresa.meucardapioPay.pixTaxaNegociada ?
      (this.empresa.meucardapioPay.pixTaxaNegociada) :
      (this.empresa.meucardapioPay.contratoMeucardapioPay.taxaPix * 100);
    this.mostrarModalNegociarPix = true;
  }

  fecharModalNegociarPix() {
    this.mostrarModalNegociarPix = false;
  }

  salvarTaxaNegociadaPix() {
    if (this.salvandoTaxaPix) return;

    this.salvandoTaxaPix = true;
    this.tunapayService.atualizeTaxaNegociadaPix({ taxaNegociada: this.taxaNegociadaPix })
      .then(() => {
        this.salvandoTaxaPix = false;
        this.empresa.meucardapioPay.pixTaxaNegociada = this.taxaNegociadaPix;
        this.fecharModalNegociarPix();
      })
      .catch((err) => {
        this.salvandoTaxaPix = false;
        this.erroTaxaPix = err.message || err;
      });
  }

  obtenhaFormatoPercentual(){
    return String(`0.00"%"`);
  }

  private provedorMeuCardapioPay() {
    return this.ehCellcoin() ? 'cellcoin' : 'tuna';
  }

  private meioPagamentoMeuCardapioPay() {
    return this.ehCellcoin() ? 'cellcoinpay' : 'tunapay';
  }

  private ehFormaDoProvedorMeuCardapioPay(forma: any) {
    return forma?.configMeioDePagamento?.meioDePagamento === this.meioPagamentoMeuCardapioPay();
  }

}
